import { render, staticRenderFns } from "./TopMain.vue?vue&type=template&id=22726b54"
import script from "./TopMain.vue?vue&type=script&lang=js"
export * from "./TopMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports